import _initializerDefineProperty from "@babel/runtime-corejs3/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime-corejs3/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import { observable, runInAction } from 'mobx';
import { udApi } from '@udemy/ud-api';
export let ProfessionalSkillsUnitStore = (_class = class ProfessionalSkillsUnitStore {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(unitData) {
    _initializerDefineProperty(this, "unitData", _descriptor, this);
    _initializerDefineProperty(this, "isLoading", _descriptor2, this);
    this.unitData = unitData;
    this.isLoading = true;
  }
  async populateSubcategoryAndTopicData() {
    var _this$unitData$availa, _this$unitData$availa3;
    const categoryIds = [...new Set(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_this$unitData$availa = this.unitData.available_filters) === null || _this$unitData$availa === void 0 ? void 0 : _this$unitData$availa.units.map(unit => unit.category_id))];
    const categoryPromiseResults = await Promise.allSettled(categoryIds.map(categoryId => udApi.get(`/course-categories/${categoryId}/subcategories/`)));
    // cast to any, because the TSC allSettled results don't match with the defined allSettled interface.
    // If you remove these lines, TSC will fail because it doesn't think 'value' or 'reason' are valid fields.
    const responses = categoryPromiseResults.filter(promise => promise.status === 'fulfilled')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(promise => promise.value);
    const rejections = categoryPromiseResults.filter(promise => promise.status === 'rejected')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(promise => promise.reason);
    const subcategories = responses.map(response => response.data.results).flat();
    runInAction(() => {
      var _this$unitData$availa2;
      (_this$unitData$availa2 = this.unitData.available_filters) === null || _this$unitData$availa2 === void 0 || _this$unitData$availa2.units.forEach(unit => {
        const subcategory = subcategories.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        subcategory => subcategory.id === unit.id);
        if (subcategory) {
          unit.title = subcategory.title;
        }
      });
    });
    const topicIds = (_this$unitData$availa3 = this.unitData.available_filters) === null || _this$unitData$availa3 === void 0 ? void 0 : _this$unitData$availa3.units.flatMap(subUnit => {
      var _subUnit$available_fi;
      return (_subUnit$available_fi = subUnit.available_filters) === null || _subUnit$available_fi === void 0 ? void 0 : _subUnit$available_fi.units.map(topicUnit => topicUnit.label_id);
    }).join(',');
    if (topicIds) {
      const response = await udApi.get(`/structured-data/enrollment-stats/?topic_ids=${topicIds}`);
      runInAction(() => {
        var _this$unitData$availa4;
        (_this$unitData$availa4 = this.unitData.available_filters) === null || _this$unitData$availa4 === void 0 || _this$unitData$availa4.units.forEach(unit => {
          for (const [topicId, stats] of Object.entries(response.data)) {
            var _unit$available_filte;
            const topicUnit = (_unit$available_filte = unit.available_filters) === null || _unit$available_filte === void 0 ? void 0 : _unit$available_filte.units.find(topicUnit => String(topicUnit.label_id) === topicId);
            if (topicUnit) {
              topicUnit.title = stats.name;
              topicUnit.num_enrollments = stats.stat_value;
            }
          }
        });
        this.isLoading = false;
      });
    }
    if (rejections.length) {
      throw rejections;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "unitData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
//# sourceMappingURL=professional-skills-unit.mobx-store.js.map